export function validateProp(prop, defaultValue=''){
    return prop? prop:defaultValue
}